import React from 'react';
import { TextField, Button, IconButton, InputAdornment, CircularProgress, Divider } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import '../../../../../styles/components/Team.css';

function AddCheckInStaff({
    onCancel = () => { },
    openAddCheckInStaffForm,
    deleteStaffMember = () => { },
    addStaffMember = () => { },
    formik,
    loading = false
}) {

    return (
        <div className="add-event-check-in-staff-container">
            <form className="add-event-staff-form" onSubmit={formik.handleSubmit} noValidate>
                <div className="add-event-staff-form-actions">
                    <Button variant="main" onClick={addStaffMember}>
                        Add Staff
                    </Button>
                </div>
                <div className="add-event-staff-form-content-container">
                    {openAddCheckInStaffForm && (
                        <div className="add-event-staff-form-content-check-in">
                            <div className="check-in-staff-inputs-list">
                                {formik.values.members.map((member, index) => (
                                    <React.Fragment key={index}>
                                        <div className="check-in-staff-inputs">
                                            <TextField
                                                fullWidth
                                                required
                                                id={`members[${index}].name`}
                                                name={`members[${index}].name`}
                                                label="Name"
                                                type="text"
                                                value={member.name}
                                                onChange={formik.handleChange}
                                                error={
                                                    formik.touched.members &&
                                                    Boolean(formik.errors.members?.[index]?.name)
                                                }
                                                helperText={
                                                    formik.touched.members &&
                                                    formik.errors.members?.[index]?.name
                                                }
                                            />
                                            <TextField
                                                fullWidth
                                                required
                                                id={`members[${index}].email`}
                                                name={`members[${index}].email`}
                                                label="Email"
                                                type="email"
                                                value={member.email}
                                                onChange={formik.handleChange}
                                                error={
                                                    formik.touched.members &&
                                                    Boolean(formik.errors.members?.[index]?.email)
                                                }
                                                helperText={
                                                    formik.touched.members &&
                                                    formik.errors.members?.[index]?.email
                                                }
                                            />
                                            <TextField
                                                fullWidth
                                                required
                                                id={`members[${index}].phone`}
                                                name={`members[${index}].phone`}
                                                label="Phone"
                                                value={member.phone}
                                                onChange={formik.handleChange}
                                                error={
                                                    formik.touched.members &&
                                                    Boolean(formik.errors.members?.[index]?.phone)
                                                }
                                                helperText={
                                                    formik.touched.members &&
                                                    formik.errors.members?.[index]?.phone
                                                }
                                                slotProps={{
                                                    input: {
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                +91
                                                            </InputAdornment>
                                                        ),
                                                        inputMode: 'numeric',
                                                        pattern: '[0-9]*',
                                                        onInput: (e) => {
                                                            e.target.value = e.target.value.replace(
                                                                /\D/g,
                                                                ''
                                                            );
                                                            if (e.target.value.length > 10) {
                                                                e.target.value =
                                                                    e.target.value.slice(0, 10);
                                                            }
                                                        }
                                                    }
                                                }}
                                            />
                                            <IconButton
                                                color="secondary"
                                                sx={{ marginTop: '0.5rem' }}
                                                onClick={() => deleteStaffMember(index)}
                                            >
                                                <HighlightOffIcon sx={{ fontSize: '1.75rem' }} />
                                            </IconButton>
                                        </div>
                                        {index !== formik.values.members.length - 1 && (
                                            <Divider
                                                sx={{
                                                    borderColor: 'var(--divider-color)',
                                                    alignSelf: 'stretch'
                                                }}
                                            />
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                            <div className="send-staff-form-actions">
                                <Button variant="text" onClick={onCancel}>
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="main"
                                    disabled={loading}
                                >
                                    Send Invitation {loading && (
                                        <CircularProgress
                                            size={20}
                                            sx={{
                                                marginLeft: '0.75rem',
                                                color: 'var(--primary-color)'
                                            }}
                                        />
                                    )}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </form>
        </div>
    );
}

export default AddCheckInStaff;